import { Component, OnInit, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  Validators,
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  IPurchasesInvoices,
  IPurchaseInvoice,
} from '../../../../../@interfaces/purchaseInvoice.interface';
import { IArticles } from '../../../../../@interfaces/article.interface';
import { IProvider } from '../../../../../@interfaces/provider.interface';
import { Subject, Observable } from 'rxjs';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { PurchasesService } from '../../../../../@pages/purchases/purchases.service';
import { ProviderService } from '../../../../../@pages/provider/provider.service';
import { InventoryService } from '../../../../../@pages/inventory/inventory.service';
import { takeUntil, startWith } from 'rxjs/operators';
import { IPurchaseQuery } from '../../../../../@interfaces/purchases.interface';
import { DialogComponent } from '../../dialog.component';
import { ModifyPurchaseService } from './modify-purchase.service';
import { RegisterPurchaseService } from '../register-purchase/register-purchase.service';
import { ICities } from '../../../../../@interfaces/cities.interface';
import { map } from 'rxjs/internal/operators/map';
import { TributaryService } from '../../../../../@pages/tributary/tributary.service';
import { ConverseFilesService } from '../../../services/files/converse-files.service';
import { IWarehouse } from 'src/app/@interfaces/warehouse.interface';
import { WarehouseService } from 'src/app/@pages/warehouse/warehouse.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { IStorageCompany } from 'src/app/@interfaces/company.interface';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';
import { TaxValidationsService } from '../../../services/validations/tax-validations.service';
import { AlertsService } from '../../../services/alerts/alerts.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { AsyncPipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { STRING_CONSTANTS } from '@shared-constants';
import { UnitConversionService } from '../../../../services/unit-conversion.service';
import { IUnits } from 'src/app/@interfaces/units.interface';
import { MatSelectModule } from '@angular/material/select';
import { ValidatorsService } from 'src/app/@shared/validator/validators.service';
import { InventoryArticleWarningComponent } from '@shared-components';

@Component({
  selector: 'app-modify-purchase',
  templateUrl: './modify-purchase.component.html',
  styleUrls: ['./modify-purchase.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatButtonModule,
    NgxSpinnerModule,
    MatProgressSpinnerModule,
    AsyncPipe,
    CurrencyPipe,
    DecimalPipe,
    TranslatePipe,
    MatSelectModule,
    InventoryArticleWarningComponent,
  ],
})
export class ModifyPurchaseComponent implements OnInit {
  @Input() id_invoice: number = 0;
  uvtValue = 0;
  totalPurchase: number = 0;
  totalWithoutTax: number = 0;
  totalTax: number = 0;
  withholdingTax: number = 0;
  icaTax: number = 0;
  loadingWithholdings = false;
  customerCity = '';
  providerCity = '';
  newArticle: UntypedFormControl = this.fb.control('', Validators.required);
  newProvider: UntypedFormControl = this.fb.control('', Validators.required);
  purchaseForm: UntypedFormGroup = this.fb.group({
    itemRows: this.fb.array([
      this.fb.group({
        ids: [],
        warehouse: ['', Validators.required],
        article: [, Validators.required],
        quantity: [
          ,
          [
            Validators.required,
            Validators.min(0.001),
            this.validatorsService.positiveDecimal,
          ],
        ],
        unit: ['', Validators.required],
        customFactor: [1],
        isFactorEditable: [false],
        quantityInBaseUnit: [0],
        price: [, Validators.required],
        discount: [0, Validators.required],
        subtotal: [0],
      }),
    ]),
    written_invoice: ['', Validators.required],
    tax_include: false,
    clause: false,
    is_electronic_document: false,
    tax: [, Validators.required],
    date: [, Validators.required],
    dueDate: [, Validators.required],
  });
  get rowsArr() {
    return this.purchaseForm.get('itemRows') as UntypedFormArray;
  }
  purcahsesIds: number[] = [];
  purchasesIdsDelete: number[] = [];
  purchaseToModify = {} as IPurchaseInvoice;
  dateToday = new Date();
  setPurchaseInvoice = {} as IPurchasesInvoices;
  purchases: Array<IPurchaseQuery> = [];
  articleList: Array<IArticles> = [];
  providersList: Array<IProvider> = [];
  warehouseList: IWarehouse[] = [];
  unitsList: IUnits[] = [];
  companyId = '';
  user = '';
  rol = '';
  unsubscribe$ = new Subject<void>();
  citiesList: ICities[] = [];
  citiesCustomerForm: UntypedFormControl = this.fb.control(
    '',
    Validators.required,
  );
  filteredOptionsCustomerCities: Observable<ICities[]> | undefined;
  companyObject = {} as IStorageCompany;

  get isElectronicInvoicing(): boolean {
    return (
      this.companyObject.internal_electronic_invoicing === STRING_CONSTANTS.TRUE
    );
  }

  constructor(
    private spinnerService: NgxSpinnerService,
    public dialog: MatDialog,
    public purchasesService: PurchasesService,
    private fb: UntypedFormBuilder,
    private providersService: ProviderService,
    private article: InventoryService,
    private modifyPurchaseService: ModifyPurchaseService,
    private registerPurchaseService: RegisterPurchaseService,
    private tributaryService: TributaryService,
    private converseFilesService: ConverseFilesService,
    private taxValidationsService: TaxValidationsService,
    private warehouse: WarehouseService,
    private alertsService: AlertsService,
    private cookieAuthService: CookieAuthService,
    private unitConversionService: UnitConversionService,
    private validatorsService: ValidatorsService,
  ) {}

  async ngOnInit() {
    this.spinner();
    this.getAuthValues();
    this.citiesList = await this.getCities();
    this.purchaseToModify = await this.getPurchaseInvoice();
    this.setPurchase(this.purchaseToModify);
    this.getInputValues();
    this.filteredArrays();
    this.data();
  }

  getAuthValues() {
    this.companyObject = this.cookieAuthService.getCompanyObject!;
    this.companyId = this.companyObject.Id_company!.toString();
    this.user = this.cookieAuthService.getUserId!;
    this.rol = this.cookieAuthService.getRolId!;
  }

  data() {
    this.warehouse
      .listWarehouses()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.warehouseList = result;
      });

    this.article
      .listUnits()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result: any) => {
        this.unitsList = result || [];
      });
  }

  async setPurchase(purchaseToModify: IPurchaseInvoice) {
    const { provider } = purchaseToModify;
    const { withholdingTax } = purchaseToModify;
    const { icaTax } = purchaseToModify;
    const { customerCity } = purchaseToModify;
    const { providerCity } = purchaseToModify;
    const { purchases } = purchaseToModify;
    this.withholdingTax = withholdingTax!;
    this.icaTax = icaTax!;
    this.providerCity = providerCity || '';
    this.setCitiesForm(customerCity!, this.citiesList);
    this.purchases = purchases;
    const [parameter] = this.purchases;
    const { total } = parameter || 0;
    this.totalPurchase = total;
    this.editPurchase(this.purchaseToModify, this.purchases, provider);
  }

  getPurchaseInvoice() {
    return new Promise<any>((resolve, reject) => {
      this.purchasesService
        .getPurchaseInvoice(this.id_invoice)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  getCities() {
    return new Promise<any>((resolve, reject) => {
      const country_id = this.companyObject.countries[0].id_country;
      this.tributaryService
        .getCitiesByCompany(parseInt(country_id!.toString()))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  filteredArrays() {
    this.filteredOptionsCustomerCities =
      this.citiesCustomerForm.valueChanges.pipe(
        startWith(''),
        map((value) => this._filterC(value)),
      );
  }

  setCitiesForm(customerCity: string, citiesList: ICities[]) {
    if (customerCity) {
      const setCustomerCity = citiesList.filter(
        (city) =>
          this.converseFilesService.removeAccents(
            city.name.toString().toLocaleLowerCase(),
          ) ===
          this.converseFilesService.removeAccents(
            customerCity.toString().toLocaleLowerCase().trim(),
          ),
      );

      if (setCustomerCity.length > 0) {
        this.citiesCustomerForm.setValue(setCustomerCity[0]);
      }
    }
    this.customerCity = customerCity!;
  }

  getInputValues() {
    this.newProvider.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: any) => {
        if (!value.__typename) {
          this.providersService
            .searchProvider(value, null, null)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((result: any) => {
              this.providersList = result.providers;
            });
        }
      });
  }

  onProviderSelected(event: MatAutocompleteSelectedEvent) {
    if (event.option.value) {
      this.calculation();
      this.providerCity = event.option.value.city;
    }
  }

  addNewRow() {
    if (this.purchaseForm.invalid) {
      return;
    }
    const newRow = this.fb.group({
      warehouse: ['', Validators.required],
      article: ['', Validators.required],
      quantity: [0, Validators.required],
      unit: ['', Validators.required],
      customFactor: [1],
      isFactorEditable: [false],
      quantityInBaseUnit: [0],
      price: [0, Validators.required],
      discount: [0, Validators.required],
      subtotal: [0, Validators.required],
    });
    this.rowsArr.push(newRow);
    this.calculation();
  }

  deleteRow(rowIndex: number, id_purchaseD: number) {
    if (this.rowsArr.length > 1) {
      this.rowsArr.removeAt(rowIndex);
      this.purchasesIdsDelete.push(parseInt(id_purchaseD.toString()));
    } else if (this.rowsArr.length === 1) {
      this.alertsService.showWarningAlert('You should not remove the last row');
    }
    this.calculation();
  }

  async editPurchase(
    purchasesInvoices: any,
    purchases: IPurchaseQuery[],
    provider: IProvider,
  ) {
    this.purchaseForm.patchValue({
      written_invoice: purchasesInvoices.contpurchase.written_invoice,
      tax: purchasesInvoices.tax,
      date: purchasesInvoices.createdAt,
      dueDate: purchasesInvoices.dueDate,
      tax_include: this.getTaxIncluded(purchasesInvoices),
      clause: this.getClause(purchasesInvoices),
      is_electronic_document: purchasesInvoices.is_electronic_document,
    });

    if (purchasesInvoices.state === 1) {
      this.purchaseForm.get('clause')?.disable();
      this.purchaseForm.get('is_electronic_document')?.disable();
    }
    this.providersService
      .getProvider(provider.id_provider!)
      .subscribe((providerRes) => {
        this.newProvider.setValue(providerRes);
      });
    this.purchaseForm.setControl(
      'itemRows',
      await this.setPurchases(purchases),
    );
  }

  getClause(purchasesInvoices: any) {
    return purchasesInvoices.clause === STRING_CONSTANTS.TRUE ? true : false;
  }

  getTaxIncluded(purchasesInvoices: any) {
    return purchasesInvoices.tax_incl === STRING_CONSTANTS.TRUE ? true : false;
  }

  async setPurchases(
    purchasesSets: IPurchaseQuery[],
  ): Promise<UntypedFormArray> {
    const formArray = new UntypedFormArray([]);
    for (let index = 0; index < purchasesSets.length; index++) {
      const purchase = purchasesSets[index];
      const article = purchase.articulo?.[0];

      // Determine unit: use id_purchase_unit if available, otherwise base unit
      // Convert to number to ensure consistency with option values
      let unitId: number | string = '';
      if ((purchase as any).id_purchase_unit) {
        unitId = Number((purchase as any).id_purchase_unit);
      } else if (article?.unit?.id_unit) {
        unitId = Number(article.unit.id_unit);
      } else if (article?.id_unit) {
        unitId = Number(article.id_unit);
      }

      // Calculate factor if we have quantity_in_base_unit
      let factor = 1;
      let isFactorEditable = false;
      const quantityInBaseUnit = (purchase as any).quantity_in_base_unit;

      // Determine the base unit ID
      const baseUnitId = article?.unit?.id_unit || article?.id_unit;

      // PRIORITY 1: Check if it's the article's packaging unit (regardless of base unit)
      if (
        article?.id_packaging_unit &&
        unitId &&
        unitId === Number(article.id_packaging_unit)
      ) {
        factor = article.packaging_unit_factor || 1;
        isFactorEditable = false;
      }
      // PRIORITY 2: Check if purchasing in non-base unit
      else if (unitId && baseUnitId && unitId !== Number(baseUnitId)) {
        // Try to get factor from unit conversions table
        try {
          const dbFactor = await this.unitConversionService
            .getConversionFactor(Number(unitId), Number(baseUnitId))
            .toPromise();
          if (dbFactor) {
            factor = dbFactor;
            isFactorEditable = false;
          } else {
            // No conversion found, calculate from quantities if available
            if (
              quantityInBaseUnit &&
              purchase.quantity &&
              purchase.quantity > 0
            ) {
              factor = quantityInBaseUnit / purchase.quantity;
            }
            isFactorEditable = true;
          }
        } catch (error) {
          // Error getting conversion, calculate from quantities if available
          if (
            quantityInBaseUnit &&
            purchase.quantity &&
            purchase.quantity > 0
          ) {
            factor = quantityInBaseUnit / purchase.quantity;
          }
          isFactorEditable = true;
        }
      }
      // PRIORITY 3: If we have quantity_in_base_unit but no unit info, calculate factor
      else if (
        quantityInBaseUnit &&
        purchase.quantity &&
        purchase.quantity > 0 &&
        quantityInBaseUnit !== purchase.quantity
      ) {
        factor = quantityInBaseUnit / purchase.quantity;
        isFactorEditable = true;
      } else {
        // Purchasing in base unit or same unit, factor is always 1
        factor = 1;
        isFactorEditable = false;
      }

      // Calculate the actual quantity in base unit
      const calculatedQuantityInBaseUnit =
        quantityInBaseUnit || purchase.quantity * factor;

      formArray.push(
        this.fb.group({
          ids: purchase.id_purchases,
          warehouse: purchase.warehouse,
          article: article,
          quantity: purchase.quantity,
          unit: unitId,
          customFactor: factor,
          isFactorEditable: isFactorEditable,
          quantityInBaseUnit: calculatedQuantityInBaseUnit,
          discount: purchase.discount,
          price: purchase.price,
          subtotal: purchase.subtotal,
        }),
      );
    }
    if (formArray.length === 0) {
      formArray.push(
        this.fb.group({
          ids: [],
          warehouse: ['', Validators.required],
          article: ['', Validators.required],
          quantity: [
            0,
            [
              Validators.required,
              Validators.min(0.001),
              this.validatorsService.positiveDecimal,
            ],
          ],
          unit: ['', Validators.required],
          customFactor: [1],
          isFactorEditable: [false],
          quantityInBaseUnit: [0],
          price: [0, Validators.required],
          discount: [0, Validators.required],
          subtotal: [0, Validators.required],
        }),
      );
    }
    const baseTax = await this.registerPurchaseService.getTaxBase();
    this.uvtValue = baseTax[0].value;
    return formArray;
  }

  validRegister() {
    if (this.purchaseForm.invalid === true) {
      this.alertsService.showErrorAlert(
        'Please, fill in all the required fields!',
      );
      this.spinnerService.hide();
      return false;
    } else if (this.rowsArr.length > 12) {
      this.alertsService.showErrorAlert(
        'The purchase cannot have more than 12 items, please delete',
        ' ' + (this.rowsArr.length - 12),
      );
      this.spinnerService.hide();
      return false;
    } else {
      return true;
    }
  }

  validDeletePurchases() {
    if (this.rowsArr.value.length === this.purchases.length) {
      for (let i = 0; i < this.purchasesIdsDelete.length; i++) {
        this.purchasesIdsDelete.pop();
      }
    }
  }

  update() {
    const validations = this.validRegister();
    if (!validations) {
      return;
    } else {
      this.spinnerService.show();
      this.calculation();
      if (
        (!this.providerCity || this.citiesCustomerForm.invalid) &&
        (this.companyObject.external_electronic_invoicing ===
          STRING_CONSTANTS.TRUE ||
          this.companyObject.internal_electronic_invoicing ===
            STRING_CONSTANTS.TRUE)
      ) {
        this.alertsService.showErrorAlert('This city does not exist');
        this.spinnerService.hide();
        return;
      } else {
        const variables = this.modifyPurchaseService.setQuotationData(
          this.purchaseForm,
          this.rowsArr,
          this.newProvider,
        );
        this.validDeletePurchases();
        this.purchasesService
          .updatePurchase(
            variables.is_electronic_document,
            variables.contpurchase!.written_invoice,
            this.id_invoice,
            variables.tax,
            this.withholdingTax,
            this.icaTax,
            this.customerCity,
            this.providerCity,
            variables.provider.id_provider!,
            variables.purchases[0].id_purchases,
            this.purchasesIdsDelete,
            variables.purchases[0].id_warehouse,
            variables.purchases[0].codigo,
            variables.purchases[0].quantity,
            variables.purchases[0].price,
            variables.purchases[0].discount,
            variables.purchases[0].subtotal,
            variables.purchases[0].total,
            variables.createdAt,
            variables.dueDate,
            variables.tax_incl!,
            variables.clause,
            parseInt(this.user!),
            variables.purchases[0].id_purchase_unit,
            variables.purchases[0].quantity_in_base_unit,
          )
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (result) => {
              if (result) {
                this.spinnerService.hide();
                this.alertsService
                  .showSuccessfullAlert(
                    'Purchase has beed updated successfully',
                  )
                  .then(async (result) => {
                    this.purchaseToModify = await this.getPurchaseInvoice();
                    this.setPurchase(this.purchaseToModify);
                    if (result.isConfirmed) {
                      this.dialog.closeAll();
                      this.alertsService.refresh('/card', '/purchases');
                    }
                  });
              } else {
                this.spinnerService.hide();
                this.alertsService.showErrorAlert('Something was wrong');
              }
            },
            (error) => {
              this.spinnerService.hide();
            },
          );
      }
    }
  }

  async calculation() {
    let priceCal = 0;
    let quantityCal = 0;
    let discountCal = 0;
    let taxCal = 0;
    let subsubtotal = 0;
    let totalWithoutTax = 0;
    let totalTax = 0;
    const contributorID = parseInt(
      this.newProvider.value.contributorType.id_contributor,
    );

    for (let i = 0; i < this.rowsArr.length; i++) {
      if (this.purchaseForm.get('tax_include')?.value === false) {
        if (this.rowsArr.value[i].article.tax[0].value === 0) {
          taxCal = this.taxValidationsService.getContributorTax(
            contributorID,
            this.purchaseForm.value.tax,
          );
        } else {
          taxCal = this.taxValidationsService.getContributorTax(
            contributorID,
            this.rowsArr.value[i].article.tax[0].value,
          );
        }
      } else {
        taxCal = 0;
      }
      priceCal = this.rowsArr.value[i].price;
      quantityCal = this.rowsArr.value[i].quantity;
      discountCal = this.rowsArr.value[i].discount;
      if (taxCal) {
        if (discountCal != 0) {
          subsubtotal = quantityCal * priceCal;
          discountCal = (discountCal / 100) * subsubtotal;
          subsubtotal = subsubtotal - discountCal;
          if (this.rowsArr.value[i].article.tax[0].value === 0) {
            taxCal = (taxCal / 100) * subsubtotal;
          } else {
            taxCal = taxCal * subsubtotal;
          }
          this.rowsArr.value[i].subtotal = subsubtotal + taxCal;
          totalTax = totalTax + taxCal;
          totalWithoutTax = totalWithoutTax + subsubtotal;
        } else {
          subsubtotal = quantityCal * priceCal;
          if (this.rowsArr.value[i].article.tax[0].value === 0) {
            taxCal = (taxCal / 100) * subsubtotal;
          } else {
            taxCal = taxCal * subsubtotal;
          }
          this.rowsArr.value[i].subtotal = priceCal * quantityCal + taxCal;
          totalTax = totalTax + taxCal;
          totalWithoutTax = totalWithoutTax + subsubtotal;
        }
      } else if (discountCal != 0) {
        subsubtotal = quantityCal * priceCal;
        discountCal = (discountCal / 100) * subsubtotal;
        this.rowsArr.value[i].subtotal = subsubtotal - discountCal;
        totalWithoutTax = totalWithoutTax + subsubtotal - discountCal;
      } else {
        subsubtotal = quantityCal * priceCal;
        this.rowsArr.value[i].subtotal = subsubtotal;
      }
    }
    this.totalPurchase = 0;
    for (let i = 0; i < this.rowsArr.length; i++) {
      this.totalPurchase = this.totalPurchase + this.rowsArr.value[i].subtotal;
    }
    this.totalTax = totalTax;
    this.totalWithoutTax = this.totalPurchase - this.totalTax;
    if (this.companyObject.countries[0].name === 'Colombia') {
      await this.calculateTaxes();
    }
  }

  async calculateTaxes() {
    this.loadingWithholdings = true;
    try {
      const result =
        await this.registerPurchaseService.calculateTaxesFromBackend(
          this.rowsArr,
          this.newProvider,
          this.customerCity,
          this.providerCity,
          this.purchaseForm.getRawValue().clause ?? false,
        );
      this.withholdingTax = result.withholdingTax;
      this.icaTax = result.icaTax;
    } finally {
      this.loadingWithholdings = false;
    }
    this.setCitiesForm(this.customerCity, this.citiesList);
  }

  onCitiesCustomer(event: any) {
    this.customerCity = event.option.value.name;
    this.setCitiesForm(this.customerCity, this.citiesList);
    this.calculation();
  }

  displayFnArticle(article: any) {
    return article && article
      ? article.descripcion +
          new String(` - (`) +
          article.tax[0].value +
          new String(`)`)
      : undefined;
  }

  displayFnProvider(provider: any) {
    return provider && provider ? provider.nombre : undefined;
  }

  spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
      this.calculation();
    }, 3000);
  }

  openDialog(i: number) {
    let dialogRef = this.dialog.open(DialogComponent, {
      disableClose: true,
      data: {
        filtro: this.newArticle,
        currentWarehouse: this.rowsArr.at(i).get('warehouse')?.value.id_almacen,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result === '') {
          return;
        }
        this.rowsArr.at(i).get('article')?.setValue(result);
        this.calculation();
      });
  }

  taxValid(tax: boolean) {
    return tax === true ? true : false;
  }

  displayFnCity(city: any) {
    return city && city ? city.name : undefined;
  }

  _filterC(value: string): ICities[] {
    const filterValueC = value.toString().toLowerCase();
    return this.citiesList.filter((option) =>
      option.name.toLowerCase().toString().includes(filterValueC),
    );
  }

  compareWarehouse(item1: any, item2: any) {
    if (item1 === null || item2 === null) {
      return false;
    }
    return item1.id_almacen === item2.id_almacen;
  }

  async onUnitOrQuantityChange(
    rowIndex: number,
    changedField: 'unit' | 'quantity' | 'factor',
  ) {
    const row = this.rowsArr.at(rowIndex);
    const article = row.get('article')?.value;
    const selectedUnit = parseInt(row.get('unit')?.value);
    const quantity = parseFloat(row.get('quantity')?.value) || 0;

    if (!article || !selectedUnit || quantity <= 0) {
      return;
    }

    const baseUnit = article.unit?.id_unit || article.id_unit;

    // Convert baseUnit to number for proper comparisons
    const baseUnitNumber = baseUnit ? Number(baseUnit) : null;

    if (!baseUnitNumber) {
      // If no base unit defined, check if using packaging unit
      if (
        article.id_packaging_unit &&
        selectedUnit === Number(article.id_packaging_unit) &&
        article.packaging_unit_factor
      ) {
        const convertedQuantity = quantity * article.packaging_unit_factor;
        row.patchValue(
          {
            quantityInBaseUnit: convertedQuantity,
          },
          { emitEvent: false },
        );
        await this.calculation();
        return;
      } else {
        // No base unit and not using packaging unit, use quantity as is
        row.patchValue(
          {
            quantityInBaseUnit: quantity,
          },
          { emitEvent: false },
        );
        await this.calculation();
        return;
      }
    }

    let factorToUse = parseFloat(row.get('customFactor')?.value) || 1;
    let shouldUpdateFactor = false;
    let isEditable = false;

    if (changedField === 'unit') {
      shouldUpdateFactor = true;

      // CASE 1: Base unit
      if (selectedUnit === baseUnitNumber) {
        factorToUse = 1;
        isEditable = false;
      }
      // CASE 2: Article's packaging unit
      else if (
        article.id_packaging_unit &&
        selectedUnit === Number(article.id_packaging_unit)
      ) {
        factorToUse = article.packaging_unit_factor || 1;
        isEditable = false;
      }
      // CASE 3: Other unit - look for conversion in DB
      else {
        try {
          const factor = await this.unitConversionService
            .getConversionFactor(selectedUnit, baseUnitNumber)
            .toPromise();

          if (factor !== null && factor !== undefined) {
            factorToUse = factor;
            isEditable = false;
          } else {
            factorToUse = 1;
            isEditable = true;
          }
        } catch (error) {
          console.error('Error getting conversion factor:', error);
          factorToUse = 1;
          isEditable = true;
        }
      }
    }
    const convertedQuantity = quantity * factorToUse;

    // Update form
    if (shouldUpdateFactor) {
      row.patchValue(
        {
          quantityInBaseUnit: convertedQuantity,
          customFactor: factorToUse,
          isFactorEditable: isEditable,
        },
        { emitEvent: false },
      );
    } else {
      // Only update converted quantity, DO NOT touch customFactor
      row.patchValue(
        {
          quantityInBaseUnit: convertedQuantity,
        },
        { emitEvent: false },
      );
    }

    await this.calculation();
  }

  getAvailableUnits(article: IArticles): IUnits[] {
    if (!article || !article.id_unit) {
      return this.unitsList;
    }

    return this.unitsList;
  }

  arrayvalid(formControl: string): boolean {
    return (
      this.rowsArr.controls.length > 0 &&
      this.rowsArr.controls.filter((control) => {
        const value = control.get(formControl)?.value;
        return value !== undefined && value !== null && value < 1;
      }).length > 0
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
